
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      localMenuList: []
    };
  },
  props: {
    columns: {
      type: Array,
      default: []
    },
    menuList: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapState("menu", ["menuBulkEditSelection"]),
    isAllItemSelected() {
      return this.menuBulkEditSelection?.length === this.menuList?.length;
    }
  },
  watch: {
    menuList: {
      handler() {
        this.setLocalMenuList();
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_BULK_EDIT_SELECTION"]),
    ...mapActions("menu", [
      "getCategories",
      "getTaxes",
      "getTags",
      "uploadImage",
      "updateMenuItem",
      "deleteMenuItem"
    ]),
    setLocalMenuList() {
      this.localMenuList = JSON.parse(JSON.stringify(this.menuList));
    },
    setLoading(index, prop, val) {
      this.localMenuList[index][prop + "Loading"] = val;
      this.localMenuList = JSON.parse(JSON.stringify(this.localMenuList));
    },
    isItemSelected(id) {
      return this.menuBulkEditSelection.includes(id);
    },
    handleItemSelection(id) {
      let selection = [...this.menuBulkEditSelection];
      if (this.isItemSelected(id)) {
        selection.splice(selection.indexOf(id), 1);
      } else {
        selection.push(id);
      }
      this.SET_MENU_BULK_EDIT_SELECTION(selection);
    },
    handleSelectAllItems() {
      if (this.isAllItemSelected) {
        this.SET_MENU_BULK_EDIT_SELECTION([]);
      } else {
        this.SET_MENU_BULK_EDIT_SELECTION(this.menuList.map((el) => el.id));
      }
    },
    async handleUpdateMenuItem(index, value, val) {
      this.setLoading(index, value, true);
      this.updateMenuItem({
        item: { id: this.localMenuList[index].id, [value]: val }
      })
        .then((response) => {})
        .catch((errr) => {
          console.log(errr);
          this.$nuxt.$emit("show-error-toast", errr);
          this.localMenuList[index][value] = this.menuList[index][value];
        })
        .finally(() => {
          this.setLoading(index, value, false);
        });
    },
    async deleteItem(index, value) {
      this.setLoading(index, value, true);
      this.deleteMenuItem(this.localMenuList[index].id)
        .then((response) => {
          this.localMenuList.splice(index, 1);
        })
        .catch((errr) => {
          console.log(errr);
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.setLoading(index, value, false);
        });
    },
    setDishType(dishType, index) {
      this.localMenuList[index]["dish_type"] = [dishType.value];
    }
  }
};
